export const calibrationDetailsRouteConfig = (id: string) => [
    { routerLink: `/dashboard/calibration-details/${id}`, title: 'Calibration Equipment Details' },
    { routerLink: `/dashboard/calibration-history/${id}`, title: 'Maintenance History' }
];